export const READY_SOLUTION_TABS = [["solutions", "Решения"], ["agents", "Агенты"], ["tasks", "Задачи"], ["results", "Результаты"], ["metrics", "Метрики"]];

// A shared agent can participate in several published solutions. The catalog
// is built from the solutions available to this session, without fetching the
// organization's private integrations or administrative agent configuration.
export function readySolutionAgents(solutions = []) {
  const agents = new Map();
  for (const solution of solutions) {
    if (solution.visibility !== "PUBLIC" || solution.integrationOnly) continue;
    for (const item of Array.isArray(solution.agents) ? solution.agents : []) {
      if (typeof item?.agentId !== "string" || !item.agentId || typeof item.name !== "string" || !item.name) continue;
      if (!agents.has(item.agentId)) agents.set(item.agentId, { ...item, solutions: [] });
      const agent = agents.get(item.agentId);
      if (!agent.solutions.some((entry) => entry.solutionId === solution.solutionId)) agent.solutions.push(solution);
    }
  }
  return [...agents.values()].map((agent) => ({
    ...agent,
    ready: agent.solutions.some((solution) => solution.status === "active" && solution.readiness?.ready !== false),
  }));
}
